import React from 'react';
import PropTypes from 'prop-types';

import {
    Anchor,
    Text,
    Spacer,
    List,
} from '@zillow/constellation';

import ListingActivationConstants from 'app/shared/constants/ListingActivationConstants';

const ErrorModal = ({
    error,
}) => {
    let errorMessage;
    let errorItems = [];

    switch (error.code) {
        case ListingActivationConstants.ERROR_CODE.INVALID_FIELDS:
            errorMessage = 'We found some invalid fields while activating your listing.';
            if (error.data.listing) {
                errorItems = Object.values(error.data.listing);
            }
            if (error.data.floorPlans) {
                errorItems.push('Please fix the errors in your floorplans.');
            }
            break;
        case ListingActivationConstants.ERROR_CODE.LISTING_ACTIVATION_BLOCKED:
            errorMessage = (
                <React.Fragment>
                    We&apos;re unable to activate this listing at this time. Please contact&nbsp;
                    <Anchor href={`mailto:${error.data.accountVerificationEmail}`} escape={true}>
                        {error.data.accountVerificationEmail}
                    </Anchor>
                </React.Fragment>
            );
            break;
        default:
            errorMessage = error.message;
    }

    return (
        <Spacer paddingX="lg" paddingBottom="md">
            <Text>
                <div
                    dangerouslySetInnerHTML={{
                        __html: `${errorMessage}`,
                    }}
                />
            </Text>
            <List>
                {errorItems.map(errorItem => <List.Item>{errorItem}</List.Item>)}
            </List>
        </Spacer>
    );
};

ErrorModal.defaultProps = {
    error: null,
};

ErrorModal.propTypes = {
    error: PropTypes.object,
};

export { ErrorModal };
export default ErrorModal;
